export default "__VITE_ASSET__BaX7mzHl__"